export default __webpack_public_path__ + "static/media/pallet.23dba9f4.png";